import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NormativesPageComponent } from './normatives-page/normatives-page.component';
import { NormativesComponent } from './normatives/normatives.component';
import { SpeedNormativesComponent } from './speed-normatives/speed-normatives.component';
import { NORMATIVES_PATHS } from './normatives';
import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: NORMATIVES_PATHS.normatives,
    component: NormativesPageComponent,
    canActivate: [AuthGuard],
    data: { animation: 'NormativesPage', permission: 'normatives.get' },
    children: [
      {
        path: NORMATIVES_PATHS.work_standards,
        component: NormativesComponent,
      },
      {
        path: NORMATIVES_PATHS.speed_standards,
        component: SpeedNormativesComponent,
      },
      {
        path: '',
        redirectTo: NORMATIVES_PATHS.work_standards,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NormativesRoutingModule {}
